import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import { MdExpandLess, MdExpandMore } from 'react-icons/md';
import SvGraphics from "../../assets/SvGraphics";
import MyTable from "../TableComponents/Table";
import PatientChart from "../../views/doctor/PatientChart";


class TreatmentOverViewBlockComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checkboxes:{}
        };
    }

    onClickCheckboxes=(event)=>{
        let {checkboxes} =this.state
        if(!checkboxes[event]){
            checkboxes[event]="Checked"
        }else{
            delete checkboxes[event];
        }
        this.setState(checkboxes)
    }
    render() {
        let {t,showDemo}=this.props
        let {checkboxes}=this.state

        let Testseries= [
            {
                name: 'Flower',
                type: 'bar',
                data: [5, 5, 5, 5, 5, 5,10]
            },
            {
            name: 'Oil',
            type: 'bar',
                data: [5, 5, 5, 5, 10, 10,10]
        }, {
            name: 'Pain',
            type: 'line',
                data: [5, 4, 3, 2.5, 2.5, 2,2]
        }, {
            name: 'Sleep disorder',
            type: 'line',
                data: [4, 4, 2.5, 2.5, 2.5, 2,1.5]
        }, {
            name: 'Opioid equivalent',
            type: 'line',
                data: [5, 5, 4, 3.5, 3, 2,0]
        }]
        let categories=["MAY-21","JUN-21","JUL-21","AUG-21","SEP-21","OCT-21","NOV-21"]

        let arr =["Pain","Sleep disorder","Opioid equivalent"]

        let colorsArr=['#005f7f','#99bfcc','#ff7200','#ffa800','#007eff']
        let options= arr.map((item,index)=>
            <div style={{display:'flex',margin:'0 35px'}}>
                <input type={"checkbox"} style={{marginTop:'8px',maxWidth:'20px',maxHeight:'20px'}}
                       checked={checkboxes[item]}
                       onChange={() => this.onClickCheckboxes(item)}/>
                <div className={'treatment-overview-label'}>{item}</div>
                <div className={'treatment-overview-label-color'} style={{backgroundColor: colorsArr[index+2]}}/>
            </div>
        )
        return (
            <div className={'Patient_Screen_tratments_block'}>
                <div className={'Patient-Screen-treatment-overview-block-1st'}>

                    {showDemo&&options}

                </div>


                <div className={'Patient-Screen-treatment-overview-block'}>

                    {showDemo&&<PatientChart series={Testseries} colors={['#005f7f', '#99bfcc', '#ff7200', '#ffa800', '#007eff']}
                                   backgroundColor={'#ffffff'}
                                   minHeight={499} showLegend={true}
                                   xCategories={categories} stacked={true}/>}

                </div>
            </div>

        );
    }
}



const TreatmentOverViewBlock = compose(
    withTranslation(),

)(TreatmentOverViewBlockComposed);

export default TreatmentOverViewBlock;

